import { PredefinedPayloadExtractor } from '../../../redux/list/list-payload-extractor';
import {
  appendNewItem,
  removeItem,
  updateItemByKey,
} from '../../../redux/list/list-update.reducer';
import {
  createDefaultListState,
  createListReducer,
  ListState,
} from '../../../redux/list/list.reducer';
import { Action, Reducer } from '../../../redux/redux.types';
import { PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES } from '../../project-overview/project-overview-members/project-overview-members.actions';
import { TEAM_MEMBER_FORM_ACTION_NAMES } from '../team-member-modal/team-member-form/team-member-form.actions';
import { TEAM_MEMBERS_ACTION_NAMES } from '../team.actions';
import { TeamMember } from '../team.types';
import { normalizeInvitation, normalizeSecurityGroups } from '../team.utils';

import { TEAM_MEMBERS_LIST_ACTION_NAMES } from './team-members-list.actions';

export type TeamMembersListState = ListState<TeamMember>;

export const teamMembersListDefaultState: TeamMembersListState =
  createDefaultListState<TeamMember>();

const membersReducer: Reducer<TeamMembersListState> = createListReducer({
  actionNames: [
    TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_START,
    TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_SUCCESS,
    TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_ERROR,
  ],
  payloadExtractorOptions: PredefinedPayloadExtractor.CallApi,
  key: 'id',
});

export const membersListState = (
  state: TeamMembersListState = teamMembersListDefaultState,
  action: Action,
): TeamMembersListState => {
  const membersState = membersReducer(state, action);

  switch (action.type) {
    case TEAM_MEMBER_FORM_ACTION_NAMES.ADD_MEMBER_SUCCESS: {
      const memberInvitation = normalizeInvitation(action.payload);

      return appendNewItem(membersState, memberInvitation, 'id');
    }

    case TEAM_MEMBER_FORM_ACTION_NAMES.EDIT_MEMBER_SUCCESS:
    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.UPDATE_MEMBER_SUCCESS:
    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.UPDATE_MEMBERS_LIST_MEMBER_SUCCESS:
    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.REMOVE_MEMBER_PERMISSIONS_SUCCESS:
    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.ADD_MEMBER_TO_PROJECT_SUCCESS:
      return updateItemByKey<TeamMember>(
        membersState,
        (teamMember) => ({
          ...teamMember,
          securityGroups: normalizeSecurityGroups(
            action.payload.securityGroups,
          ),
        }),
        action.payload.memberId,
      );

    case TEAM_MEMBERS_LIST_ACTION_NAMES.DELETE_TEAM_MEMBER_SUCCESS:
      return removeItem(membersState, action.payload);

    default:
      return membersState;
  }
};
